import { Component, ViewChild, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { ModalBase } from '../../models/modal-base';
import { FormGroup } from '@angular/forms';
import { BaseServiceService } from '../../services/base-service.service'
import { StaticData } from '../../helpers/static-data'
import { Base64 } from 'js-base64';
import { Utilities } from '../../helpers/utilities';
import { CrudActions } from '../../models/general.enum';
import { ModalNotifyComponent } from '../modal-notify/modal-notify.component';
//import { asEnumerable } from 'linq-js';
import { Router } from '@angular/router';
import { List, Enumerable } from 'linqts';
import { GeneralComunicationService } from '../../services/general-comunication.service';
import { NavItem } from '../menu-item/nav-item';
import { APP_ROUTES } from 'src/app/app.routes';
import { GeneralFormComponent } from '../controls/general-form/general-form.component';
declare var fabric: any;
declare var _spPageContextInfo: any;
declare var SP: any;
//
declare var ExecuteOrDelayUntilScriptLoaded: any;
//
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @ViewChild(ModalNotifyComponent, { static: false }) modalNotifyLogin: ModalNotifyComponent;
  @Output() endEmitter: EventEmitter<any> = new EventEmitter<any>();
  botonProcesando: boolean = false;
  textoBoton: string = 'Login';
  textoBotonProcesando: string = '';
  model: any = { UData: 'marlong@bextsa.com', CData: '', TipoSistema: null, AppKey: null };
  dialogResult: boolean = false;
  constructor(public baseService: BaseServiceService, public utility: Utilities, private router: Router,
    public comunicationService: GeneralComunicationService) {

  }

  // let  TEMP_APP_ROUTES: Routes = []
  SetProcesando(ok: boolean) {
    this.botonProcesando = ok;
    if (ok) {
      this.textoBoton = '';
      this.textoBotonProcesando = 'Ejecutando.......';
    }
    else {
      this.textoBoton = 'Login';
      this.textoBotonProcesando = '';
    }
  }
  ngOnInit() {

    this.SetProcesando(false);
  }

  ngAfterViewInit() {
    var SpinnerElements = document.querySelectorAll(".ms-Spinner");
    for (var i = 0; i < SpinnerElements.length; i++) {
      new fabric['Spinner'](SpinnerElements[i]);
    }

    this.loginSHP();

    //   try {
    //     ExecuteOrDelayUntilScriptLoaded( => {

    //         //debugger;
    //         var siteCollectionURL = _spPageContextInfo.siteAbsoluteUrl;
    //         var context = new SP.ClientContext.get_current();
    //         var web = context.get_web();
    //         var currentUser = web.get_currentUser();
    //         currentUser.retrieve();
    //         context.load(web);
    //         context.executeQueryAsync(function () {
    //             //debugger;
    //             var userObject = web.get_currentUser();
    //             try {
    //                 var email = userObject.get_email();
    //                 var id = userObject.get_id();
    //                 var loginName = userObject.get_loginName();
    //                 var title = userObject.get_title();
    //                 //$rootScope.Usuario = title;

    //                 console.log(userObject);
    //                 $rootScope.ObjUsuario = { Title: title, Usuario: userObject, Email: email, IdUsuario: id, LoginName: loginName };
    //                 if (callback)
    //                     callback($rootScope.ObjUsuario);
    //             }
    //             catch (err) {
    //                 $rootScope.Usuario = null;
    //                 $rootScope.ObjUsuario = null;
    //                 console.log(err);
    //             }
    //         }, function (o, args) {
    //             //debugger;
    //             return callback(args.get_message());
    //         });
    //     }, "sp.js");
    // }
    // catch (err) {

    //     console.log(err);
    // }
  }


  // public TestSHP(){
  //   try {

  //         //debugger;
  //         var siteCollectionURL = _spPageContextInfo.siteAbsoluteUrl;
  //         var context = new SP.ClientContext.get_current();
  //         var web = context.get_web();
  //         var currentUser = web.get_currentUser();
  //         currentUser.retrieve();
  //         context.load(web);
  //         context.executeQueryAsync(function () {
  //             //debugger;
  //             var userObject = web.get_currentUser();
  //             try {
  //                 var email = userObject.get_email();
  //                 var id = userObject.get_id();
  //                 var loginName = userObject.get_loginName();
  //                 var title = userObject.get_title();
  //                 //$rootScope.Usuario = title;

  //                 console.log(userObject);
  //                 // $rootScope.ObjUsuario = { Title: title, Usuario: userObject, Email: email, IdUsuario: id, LoginName: loginName };
  //                 // if (callback)
  //                 //     callback($rootScope.ObjUsuario);
  //             }
  //             catch (err) {
  //                 // $rootScope.Usuario = null;
  //                 // $rootScope.ObjUsuario = null;
  //                 console.log(err);
  //             }
  //         }, function (o, args) {
  //             debugger;
  //             console.log(args);
  //            // return callback(args.get_message());
  //         });

  // }
  // catch (err) {

  //     console.log(err);
  // }
  // }
  public GetDatosEstilos(estilosPorRole: List<any>, estilosGenerales: List<any>, nombreKey: any, valorPorDefecto: any): any {
    let obj = estilosPorRole.FirstOrDefault(x => x.Nombre == nombreKey);
    if (!obj)
      obj = estilosGenerales.FirstOrDefault(x => x.Nombre == nombreKey);
    if (!obj)
      return valorPorDefecto;
    else
      return obj.Valor;
  }
  public SetStyle(estilos: any, objetoColor: any, valorPorDefecto: any): any {
    let obj = (valorPorDefecto) ? valorPorDefecto : {};
    if (estilos && estilos.split(';').length > 1 && estilos.split(':').length > 1) {
      obj = { color: null };
      if (objetoColor)
        obj.color = objetoColor;
      $.each(estilos.split(';'), function (key, val) {

        obj[val.split(':')[0]] = val.split(':')[1].trim();
      });
    }
    return obj;
  }


  public CrearMenus(menus: any, parentMenu: NavItem, isFirst: boolean, context: LoginComponent) {
    var i = 0;
    $.each(menus, function (key, menuItem: any) {
      //angular.forEach(menus, function (menuItem, key) {

      let config = (menuItem.Configuracion) ? JSON.parse(menuItem.Configuracion) : { iconName: null, sigla: null };

      let currrent: NavItem = {
        displayName: menuItem.Menu,
        disabled: false,
        iconName: (config.IconName) ? config.IconName : config.iconName,
        sigla: (config.Sigla) ? config.Sigla : config.sigla,
        children: [],
        style: '',
        colorMenu: '',
        menu: menuItem
      };


      var style = (StaticData.Estilos.Menu) ? context.utility.Clone(StaticData.Estilos.Menu) : '';

      if (currrent.menu.ColorMenu) {
        style.background = currrent.menu.ColorMenu;
      }
      currrent.style = style;

      //CM
      /*
      let _ReportesUsuario = new List<any>(StaticData.Usuario.ReportesUsuario);
      var report = _ReportesUsuario.Where(x => { return x.IdMenu == menuItem.IdMenu }).FirstOrDefault();
      */

      if (menuItem.IdPagina) {
        //currrent.callback = $scope.MenuNavigate;
      }

      //CM
      /*
      else if (report) {
        // currrent.callback = $scope.MenuNavigate;
        currrent.menu.Report = report;
        currrent.menu.Ruta = 'ReporteGeneral';
      }
      */

      var menusHijos = new List<any>(StaticData.Usuario.MenusUsuario).Where(x => { return x.IdMenuPadre == menuItem.IdMenu }).ToArray();
      if (menusHijos.length > 0) {

        context.CrearMenus(menusHijos, currrent, false, context);
      }
      if (isFirst == true) {

        if (!menuItem.IdMenuPadre) {
          parentMenu.children.push(currrent);
        }
      }
      else {
        if (parentMenu) {
          parentMenu.children.push(currrent);
        }
      }
    });
  }

  onSubmit(frm: FormGroup, email: string) {
    StaticData.InitData();
    //this. baseService.modalNotify =this.modalNotifyLogin;
    //this.router.config.push( { path: 'formMdbostrap', component: FormMdbostrapComponent });
    const that = this;
    that.SetProcesando(true);
    that.comunicationService.raiseNavItemsEvent([]);


    //
    if (email != null) {
      this.model.UData = email;
    }
    //

    let modeloTemp = this.utility.Clone(this.model);
    modeloTemp.UData = btoa(this.model.UData);
    modeloTemp.AppKey = StaticData.AppKey;
    //modeloTemp.CData = btoa(this.model.CData);
    let obj = this.utility.GetApiModel('Login', '', CrudActions.None, null, modeloTemp);
    this.baseService.Login(obj, frm,
      { componentName: 'ModalLoginComponent', method: 'Login', processMessage: 'Procesando credenciales....' },
      'AuthenticationBase', true, true).then(data => {


        if (!data.Data || data.Data.Table === undefined || data.Data.Table[0] === undefined) {
          that.utility.VerModalWarning(
            { titulo: 'Mensaje Alerta', descripcion: 'El usuario no es valido en el sistema.....', verOk: true, verCancelar: false, ok: 'ACEPTAR', cancelar: 'NO' }).then(data => { });

          //throw 'El usuario no es valido en el sistema';
          return;
        }
        StaticData.Usuario = data.Data.Table[0];
        StaticData.Usuario.Token = data.Data.Token;

        if (StaticData.Usuario.Activo == false) {
          StaticData.Usuario = null;
          that.utility.VerModalWarning(
            { titulo: 'Mensaje Alerta', descripcion: 'El usuario no se encuentra activo.....', verOk: true, verCancelar: false, ok: 'ACEPTAR', cancelar: 'NO' }).then(data => { });


          //throw 'El usuario no se encuentra activo';
          return;
        }
        if (!data.Data.Token) {
          StaticData.Usuario = null;


          that.utility.VerModalWarning(
            { titulo: 'Mensaje Alerta', descripcion: 'Token Invalido....', verOk: true, verCancelar: false, ok: 'ACEPTAR', cancelar: 'NO' }).then(data => { });

          //throw 'El usuario no se encuentra activo';
          return;
        }
        //debugger;
        StaticData.Usuario.MenusUsuario = data.Data.Table1;
        StaticData.Usuario.PaginasUsuario = data.Data.Table2;
        StaticData.Usuario.Paginas = data.Data.Table3;
        // CM
        //StaticData.Usuario.ReportesUsuario = data.Data.Table4;


        StaticData.GeneralConfig = data.Data.GeneralConfig;


        if (!StaticData.GeneralConfig.ConfigUI.TiempoMensajesAdicionalModalEnNotifi)
          StaticData.GeneralConfig.ConfigUI.TiempoMensajesAdicionalModalEnNotifi = 500;

        if (!StaticData.GeneralConfig.ConfigUI.TiempoNotificacionError)
          StaticData.GeneralConfig.ConfigUI.TiempoNotificacionError = 500;
        if (!StaticData.GeneralConfig.ConfigUI.TiempoNotificacionAlerta)
          StaticData.GeneralConfig.ConfigUI.TiempoNotificacionAlerta = 500;
        if (!StaticData.GeneralConfig.ConfigUI.TiempoNotificacionOk)
          StaticData.GeneralConfig.ConfigUI.TiempoNotificacionOk = 500;
        if (!StaticData.GeneralConfig.ConfigUI.TiempoNotificacionInfo)
          StaticData.GeneralConfig.ConfigUI.TiempoNotificacionInfo = 500;

        if (data.Data.ToolBox) {
          StaticData.ToolBox = JSON.parse(data.Data.ToolBox.StringValue);
          StaticData.ToolBox.Id = data.Data.ToolBox.Id;
          StaticData.ToolBox.TipoDato = data.Data.ToolBox.TipoDato;
          StaticData.ToolBox.Name = data.Data.ToolBox.Name;
        }
        StaticData.WorkFlowTaskConfig = data.Data.WorkFlowTaskConfig;
        /* 
                $.each(StaticData.Usuario.PaginasUsuario, function (key, pagina) {
        
                  // > [8, 10]
                  //var camposPaginas = Enumerable.From(data.Data.Table5).Where(function (x) { return x.IdPagina == pagina.IdPagina }).ToArray();
        
                  var paginaConfig = {
                    IdPagina: pagina.IdPagina,
                    Nombre: pagina.Pagina, Config: {}
                  };
                  if(pagina.Configuracion){
        
                  }
        
                  StaticData.ConfigPaginas.push(paginaConfig);
                }); */



        StaticData.Usuario.Rules = data.Data.Rules;

        //CM 
        /*
        $.each(StaticData.Usuario.ReportesUsuario, function (key, reporte) {

          if (reporte.ConfiguracionFiltro && reporte.ConfiguracionFiltro !== null) {
            reporte.ConfigFilter = JSON.parse(reporte.ConfiguracionFiltro);
            let shapes = new List<any>(reporte.ConfigFilter.Shapes);
            reporte.ConfigFilter.Shapes = shapes.Where(x => x.Active == true).ToArray();
            // reporte.ConfigFilter.Shapes = Enumerable.From(reporte.ConfigFilter.Shapes).Where(function (x) { return x.Active == true }).ToArray();
          }
        });
        */





        // let BotonesComoMenu = StaticData.ParametrosGenerales.Where(x=>{return x.Nombre=='BotonesComoMenu' }).FirstOrDefault();
        // StaticData.BotonesComoMenu =(BotonesComoMenu)?BotonesComoMenu.ValorFalsoVerdadero:false;

        let estilosGenerales = (data.Data.Table4 && data.Data.Table4.length > 0) ? new List<any>(data.Data.Table4) : new List<any>([]);
        let estilosPorRole = (data.Data.Table5 && data.Data.Table5.length > 0) ? new List<any>(data.Data.Table5) : new List<any>([]);

        StaticData.ParametrosGenerales = (data.Data.Table6) ? new List<any>(data.Data.Table6) : new List<any>([]);
        /*  let ConfigGeneral = StaticData.ParametrosGenerales.FirstOrDefault(x => { return x.Nombre == 'ConfigGeneral' });
         if (ConfigGeneral) {
           StaticData.ConfigGeneral = JSON.parse(ConfigGeneral);
          
         } */
        //debugger;
        StaticData.RolesUsuariosGrupos = new List<any>(data.Data.Table7);
        StaticData.Carpetas = new List<any>(data.Data.Table8);
        StaticData.AreasEmpresa = new List<any>(data.Data.Table9);
        StaticData.Series = new List<any>(data.Data.Table10);
        StaticData.SubSeries = new List<any>(data.Data.Table11);

        let BotonesComoMenu: string = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'BotonesComoMenu', '');
        StaticData.BotonesComoMenu = false;

        if (BotonesComoMenu &&
          (BotonesComoMenu.toLowerCase() == 'si' ||
            BotonesComoMenu.toLowerCase() == 'ok' ||
            BotonesComoMenu.toLowerCase() == 'yes' ||
            BotonesComoMenu.toLowerCase() == 'true' ||
            BotonesComoMenu.toLowerCase() == '1'))
          StaticData.BotonesComoMenu = true;


        let Tema = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'Tema', '');

        let ColorMenu = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorMenu', 'blue');
        let ColorTitulos = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorTitulos', 'blue');
        let ColorBotonGuardar = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorBotonGuardar', 'blue');

        let ColorBotonLimpiar = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorBotonLimpiar', 'blue');
        let ColorBotonFiltro = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorBotonFiltro', 'blue');
        let ColorBotonImportar = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorBotonImportar', 'blue');
        let ColorBotonExportarExcel = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorBotonExportarExcel', 'blue');
        let ColorBotonExportarCsv = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorBotonExportarCsv', 'blue');
        let ColorBotonRedireccion = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorBotonRedireccion', 'blue');
        let ColorBotonBuscar = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ColorBotonBuscar', 'blue');

        let ClassMenu = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassMenu', '');
        //let ClassTitulos =that.GetDatosEstilos(estilosPorRole,estilosGenerales,'ClassTitulos','blue');
        let ClassBotonGuardar = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassBotonGuardar', 'btn btn-outline-success');
        let ClassBotonLimpiar = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassBotonLimpiar', 'btn btn-outline-info');
        let ClassBotonFiltro = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassBotonFiltro', 'btn btn-outline-info');
        let ClassBotonImportar = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassBotonImportar', 'btn btn-outline-info');
        let ClassBotonExportarExcel = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassBotonExportarExcel', 'btn btn-outline-info');
        let ClassBotonExportarCsv = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassBotonExportarCsv', 'btn btn-outline-info');
        let ClassBotonRedireccion = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassBotonRedireccion', 'btn btn-outline-info');
        let ClassBotonBuscar = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassBotonBuscar', 'btn btn-outline-info');
        let ClassTitulo = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassTitulo', '');

        let ClassContenedorGeneral = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassContenedorGeneral', 'container');
        let ClassContenedor = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassContenedor', 'container card');
        let ClassHeader = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassHeader', 'card-header info-color white-text text-center py-4');
        let ClassContenedorForm = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassContenedorForm', 'card-body px-lg-5 pt-0');

        let ClassContenedorControlesAdd = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassContenedorControlesAdd', '');

        let ClassControles = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassControles', 'md-form');

        let ClassBotonOpcion = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassBotonOpcion', 'btn btn-info btn dropdown-toggle');

        let _EstiloTitulo = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloTitulo', 'blue');
        let EstiloTitulo = that.SetStyle(_EstiloTitulo, ColorTitulos, { color: ColorTitulos });
        let _EstiloBotonGuardar = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloBotonGuardar', '');
        let EstiloBotonGuardar = that.SetStyle(_EstiloBotonGuardar, ColorBotonGuardar, {
          'background-color': ColorBotonGuardar,
          'border-color': ColorBotonGuardar,
          'cursor': 'pointer'
        });
        let _EstiloBotonLimpiar = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloBotonLimpiar', '');
        let EstiloBotonLimpiar = that.SetStyle(_EstiloBotonLimpiar, ColorBotonLimpiar, {
          'background-color': ColorBotonLimpiar,
          'border-color': ColorBotonLimpiar,
          'cursor': 'pointer'
        });

        let _EstiloBotonFiltro = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloBotonFiltro', '');
        let EstiloBotonFiltro = that.SetStyle(_EstiloBotonFiltro, ColorBotonFiltro, {
          'background-color': ColorBotonFiltro,
          'border-color': ColorBotonFiltro,
          'cursor': 'pointer'
        });

        let _EstiloBotonImportar = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloBotonImportar', '');
        let EstiloBotonImportar = that.SetStyle(_EstiloBotonImportar, ColorBotonImportar, {
          'background-color': ColorBotonImportar,
          'border-color': ColorBotonImportar,
          'cursor': 'pointer'
        });
        let _EstiloBotonExportarExcel = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloBotonExportarExcel', '');
        let EstiloBotonExportarExcel = that.SetStyle(_EstiloBotonExportarExcel, ColorBotonExportarExcel, {
          'background-color': ColorBotonExportarExcel,
          'border-color': ColorBotonExportarExcel,
          'cursor': 'pointer'
        });
        let _EstiloBotonExportarCsv = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloBotonExportarCsv', '');
        let EstiloBotonExportarCsv = that.SetStyle(_EstiloBotonExportarCsv, ColorBotonExportarCsv, {
          'background-color': ColorBotonExportarCsv,
          'border-color': ColorBotonExportarCsv,
          'cursor': 'pointer'
        });

        let _EstiloBotonRedireccion = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloBotonRedireccion', '');
        let EstiloBotonRedireccion = that.SetStyle(_EstiloBotonRedireccion, ColorBotonRedireccion, {
          'background-color': ColorBotonRedireccion,
          'border-color': ColorBotonRedireccion,
          'cursor': 'pointer'
        });

        let _EstiloBotonBuscar = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloBotonBuscar', '');
        let EstiloBotonBuscar = that.SetStyle(_EstiloBotonBuscar, ColorBotonBuscar, {
          'background-color': ColorBotonBuscar,
          'border-color': ColorBotonBuscar,
          'cursor': 'pointer'
        });



        let _EstiloContenedorGeneral = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloContenedorGeneral', '');
        let EstiloContenedorGeneral = that.SetStyle(_EstiloContenedorGeneral, null, null);

        let _EstiloContenedor = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloContenedor', '');
        let EstiloContenedor = that.SetStyle(_EstiloContenedor, null, null);
        let _EstiloHeader = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloHeader', '');
        let EstiloHeader = that.SetStyle(_EstiloHeader, null, null);
        let _EstiloContenedorForm = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloContenedorForm', '');
        let EstiloContenedorForm = that.SetStyle(_EstiloContenedorForm, null, null);


        let _EstiloContenedorControlesAdd = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'EstiloContenedorControlesAdd', '');
        let EstiloContenedorControlesAdd = that.SetStyle(_EstiloContenedorControlesAdd, null, null);



        let ClassNodos = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassNodos', '');//'container alert alert-primary'
        let ClassNodosNuevos = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassNodosNuevos', '');
        let ClassNodosEliminados = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassNodosEliminados', '');
        let ClassNodosModificados = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassNodosModificados', '');
        let ClassNodosCambioPadre = that.GetDatosEstilos(estilosPorRole, estilosGenerales, 'ClassNodosCambioPadre', '');


        StaticData.Estilos = {
          EstiloBotonGuardar: EstiloBotonGuardar,
          EstiloBotonLimpiar: EstiloBotonLimpiar,
          EstiloBotonFiltro: EstiloBotonFiltro,
          EstiloBotonImportar: EstiloBotonImportar,
          EstiloBotonExportarExcel: EstiloBotonExportarExcel,
          EstiloBotonExportarCsv: EstiloBotonExportarCsv,
          ClassBotonGuardar: ClassBotonGuardar,
          ClassBotonLimpiar: ClassBotonLimpiar,
          ClassBotonFiltro: ClassBotonFiltro,
          ClassBotonImportar: ClassBotonImportar,

          ClassBotonExportarExcel: ClassBotonExportarExcel,
          ClassBotonExportarCsv: ClassBotonExportarCsv,
          ClassControles: ClassControles,
          ClassBotonOpcion: ClassBotonOpcion,
          EstiloTitulo: EstiloTitulo,
          ClassTitulo: ClassTitulo,
          EstiloContenedor: EstiloContenedor,
          ClassContenedor: ClassContenedor,

          EstiloHeader: EstiloHeader,
          ClassHeader: ClassHeader,
          EstiloContenedorForm: EstiloContenedorForm,
          ClassContenedorForm: ClassContenedorForm,
          EstiloContenedorGeneral: EstiloContenedorGeneral,
          ClassContenedorGeneral: ClassContenedorGeneral,
          EstiloContenedorControlesAdd: EstiloContenedorControlesAdd,
          ClassContenedorControlesAdd: ClassContenedorControlesAdd,
          Tema: Tema,
          EstiloBotonRedireccion: EstiloBotonRedireccion,
          ClassBotonRedireccion: ClassBotonRedireccion,
          EstiloBotonBuscar: EstiloBotonBuscar,
          ClassBotonBuscar: ClassBotonBuscar,
          ClassNodos: ClassNodos,
          ClassNodosNuevos: ClassNodosNuevos,
          ClassNodosEliminados: ClassNodosEliminados,
          ClassNodosModificados: ClassNodosModificados,
          ClassNodosCambioPadre: ClassNodosCambioPadre,
          MenuSuperior: {
            'border-bottom': ColorMenu + ' 2px solid'

          },
          Linea: {
            height: '50px', 'border-bottom': ColorMenu + ' 2px solid'

          },



        };





        let MainMenu: NavItem = {
          displayName: '',
          disabled: false,
          iconName: '',
          sigla: '',
          children: [],
          style: '',
          colorMenu: '',
          menu: {}
        };


        //debugger;
        if (StaticData.Usuario.MenusUsuario) {
          that.CrearMenus(StaticData.Usuario.MenusUsuario, MainMenu, true, that);

          let Temp = MainMenu.children;
        }
        else
          console.log("No Hay menus asignados");
        //debugger;
        StaticData.Usuario.Paginas.filter(pagina => { return pagina.IsCustom; }).forEach(element => {


          let rout = APP_ROUTES.find(t => t.path == element.Ruta);
          if (!rout)
            APP_ROUTES.push({ path: element.Ruta, component: GeneralFormComponent });


          // this.router.config.push({ path: element.Ruta, component: GeneralFormComponent });
        });
        let rout = APP_ROUTES.find(t => t.path == "**");
        if (!rout)
          APP_ROUTES.push({ path: '**', pathMatch: 'full', redirectTo: 'Home' });

        this.router.resetConfig(APP_ROUTES);
        that.comunicationService.raiseNavItemsEvent(MainMenu.children);
        that.SetProcesando(false);


        that.endEmitter.emit(true);

      }).catch(error => {
        console.log(error);
        that.SetProcesando(false);
        that.endEmitter.emit(false);

        that.comunicationService.raiseLoginErrorEvent(error);
      });

    //baseService

  }


  public loginSHP() {
    try {
      const that = this;
      ExecuteOrDelayUntilScriptLoaded(function () {
        var siteCollectionURL = _spPageContextInfo.siteAbsoluteUrl;
        var context = new SP.ClientContext.get_current();
        var web = context.get_web();
        var currentUser = web.get_currentUser();
        currentUser.retrieve();
        context.load(web);
        context.executeQueryAsync(function () {

          var userObject = web.get_currentUser();
          try {
            var email = userObject.get_email();
            var id = userObject.get_id();
            var loginName = userObject.get_loginName();
            var title = userObject.get_title();
            console.log(userObject);
            console.log(loginName);
            if (email !== undefined && email != '') {
              that.onSubmit(null, email);
            }
          }
          catch (err) {
            console.log(err);
          }
        }, function (o, args) {
          debugger;
          console.log(args);
        });
      }, "sp.js");
    }
    catch (err) {

      console.log(err);
    }
  }


  resultmodalNotify(data: any) {

  }

}
